// extracted by mini-css-extract-plugin
module.exports = {"selectionButton":"selectionButton_selectionButton__2CcBx","buttonLogo":"selectionButton_buttonLogo__3Ky9Z"};